/**
 * Notae App
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */


export interface DocumentType { 
    /**
     * name of the type of document(ex. letter, contract, list)
     */
    name?: string;
    /**
     * title of the relation between doc type and document
     */
    title?: string;
    doubt?: string;
}
